import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, QueryList, Renderer2, ViewChild, ViewChildren } from '@angular/core';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ProtocolQ, ProtocolStatus } from 'src/app/model/protocol';
import { User } from 'src/app/model/user';
import { MyErrorStateMatcher } from 'src/app/utils/errorStateMatcher';
import { GenericClass } from 'src/app/model/genericClass';
import { Client } from 'src/app/model/client';
import { SpinnerService } from 'src/app/services/spinner.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Constants } from 'src/app/utils/constants';
import { Subject, takeUntil, filter } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { ProtocolQService } from 'src/app/services/protocolQ.service';
import { ClientService } from 'src/app/services/client.service';
import { UsersService } from 'src/app/services/users.service';
import { ProcessService } from 'src/app/services/process.service';
import { MatDialog } from '@angular/material/dialog';
import { SnackBarService } from 'src/app/services/snackBar.service';
import { ActionConfirmPasswordComponent } from '../../shared/action-confirm-password/action-confirm-password.component';
import { ProtocolQEditAuditComponent } from './protocol-q-edit-audit/protocol-q-edit-audit.component';
import { TestQualificationTypeService } from '../../../services/testQualificationType.service';
import { TestQualificationTypeShort } from '../../../model/testQualificationType';
import { TestQType, TestTypeEnum } from '../../../model/testQType';
import { GroupTestQDataVerification } from 'src/app/model/groupTestQDataVerification';
import { ProtocolQTest, ProtocolQGeneralData } from '../../../model/protocol';
import { MatCheckbox, MatCheckboxChange } from '@angular/material/checkbox';
import { MatTable } from '@angular/material/table';
import { EditReferenceDocsComponent } from '../../shared/edit-reference-docs/edit-reference-docs.component';
import * as _ from 'lodash';
import { ReferenceDocument } from 'src/app/model/referenceDocument';
import { EquipmentQualificates } from 'src/app/model/equipment';
import { ConfirmationDialogComponent } from '../../shared/confirmation-dialog/confirmation-dialog.component';
import { ProtocolQEditTestComponent } from './protocol-q-edit-test/protocol-q-edit-test.component';
import { ProtocolQTestsService } from '../../../services/protocol-qtests.service';
import { ProtocolQEditSectionTemplateComponent } from './protocol-q-edit-section-template/protocol-q-edit-section-template.component';
import { ProtocolQEditGenerateReportComponent } from './protocol-q-edit-generate-report/protocol-q-edit-generate-report.component';
import { ReasonDialogComponent } from '../../shared/reason-dialog/reason-dialog.component';
import { EditDocumentCodeEditComponent } from '../../shared/edit-document-code-edit/edit-document-code-edit.component';
import { DialogDataConfirmSave, ProtocolEditConfirmSaveComponent } from './protocol-edit-confirm-save/protocol-q-edit-confirm-save.component';
import { ProtocolEditEquipmentDialogComponent } from './protocol-edit-equipment-dialog/protocol-q-edit-equipment-dialog.component';
import { UserService } from '../../../services/user.service';
import { ArrayUtils } from '../../../utils/arrayUtils';
import { SignInfo } from '../../../model/sign';
import { ProtocolQEditDialogAutomaticSignComponent } from './protocol-q-edit-dialog-automatic-sign/protocol-q-edit-dialog-automatic-sign.component';
import { CheckWarnsErrorsComponent } from '../../shared/check-warns-errors/check-warns-errors.component';
import { GenericWarnError } from '../../../model/genericClass';
import { ProtocolQEditDialogManualSignComponent } from './protocol-q-edit-dialog-manual-sign/protocol-q-edit-dialog-manual-sign.component';
import { ProtocolQEditAttachmentsComponent } from './protocol-edit-attachments/protocol-q-edit-attachments.component';
import { QualificationTypeEnum } from 'src/app/model/verificationQType';
import { MatSelect, MatSelectChange } from '@angular/material/select';
import { InstrumentationUse } from '../../../model/instrumentationUse';
import { SignatureDocument, SignatureDocumentUsers } from '../../../model/signatureDocumentUsers';
import { DocumentListEnum } from '../../../utils/documentListUtils';
import { SignatureEditSignersComponent } from '../../signature/signature-edit-signers/signature-edit-signers.component';
import { SignatureDocumentUsersService } from '../../../services/signatureDocumentUsers.service';
import { SignatureDocumentsService } from '../../../services/signatureDocuments.service';
import { ProtocolUtils } from '../../../utils/protocolUtils';
import { ProtocolQTestGeneralDataService } from '../../../services/protocolQTestGeneralData.service';
import { ConfirmationDialogSignatureComponent } from '../../signature/confirmation-dialog-signature/confirmation-dialog-signature.component';
import { AppTypeEnum } from '../../../model/appType';

@Component({
    selector: 'app-protocol-q-edit',
    templateUrl: './protocol-q-edit.component.html',
    standalone: false,
})
export class ProtocolQEditComponent implements OnInit {

  @ViewChild(ProtocolQEditAuditComponent) auditTab: ProtocolQEditAuditComponent; // Crear Audit propio
  @ViewChild('refDocTable', { static: true }) refDocTable: MatTable<any>;
  @ViewChildren('attachmentsComponent') attachmentsComponent: ProtocolQEditAttachmentsComponent;
  @ViewChild('checkTest', { static: true }) checkboxTest: MatCheckbox;
  @ViewChild('selectTestPerformed', { static: true }) selectTestPerformed: MatSelect;

  form: FormGroup;
  matcher = new MyErrorStateMatcher();
  protocol: ProtocolQ;

  clients: Client[];
  clientsFiltered: Client[];
  processes: GenericClass[];
  respField: User[];
  groupSelected: GroupTestQDataVerification[] = [];
  testQualificationTypeList: TestQualificationTypeShort[] = [];
  testQualificationTypes: TestQualificationTypeShort[] = [];
  currentUser: User;
  pendingSigns: SignInfo[];
  instrumentationUse: InstrumentationUse[] = [];
  isEnabledSignature: boolean = false;
  existsPendingSignature: boolean = false;
  signatureDocument: SignatureDocumentUsers;
  private destroy$ = new Subject<void>();
  // eslint-disable-next-line @typescript-eslint/member-ordering
  displayedColsRefDoc = ['code', 'name', 'edit', 'delete'];
  allowedDataIQ: number[] = [TestTypeEnum.VERIFICATION_CALIBRATION_INSTRUMENTATION_CRITICAL_EQUIPMENT, TestTypeEnum.VERIFICATION_COMPONENTS_EQUIPMENT_DIMENSIONS_MATERIALS,
  TestTypeEnum.VERIFICATION_LOCATION_ASSOCIATED_SERVICES, TestTypeEnum.MATCHING_INSTALLATION_PLANS, TestTypeEnum.EQUIPMENT_DOCUMENTATION_VERIFICATION, TestTypeEnum.EQUIPMENT_VERIFICATION,
  TestTypeEnum.VERIFICATION_APPROVAL_DESIGN_QUALIFICATION, TestTypeEnum.VERIFICATION_APPROVAL_PROTOCOL_QUALIFICATION];

  testsPerformed = [{ id: QualificationTypeEnum.IQ, description: QualificationTypeEnum.IQ_DESCRIPTION }, { id: QualificationTypeEnum.OQ, description: QualificationTypeEnum.OQ_DESCRIPTION }, { id: QualificationTypeEnum.PQ, description: QualificationTypeEnum.PQ_DESCRIPTION }];
  testsSelectedProtocol: string[];
  showValidatorSpecifics = false;

  constructor(
    fb: FormBuilder,
    private clientService: ClientService,
    public dialog: MatDialog,
    private processService: ProcessService,
    private protocolService: ProtocolQService,
    private route: ActivatedRoute,
    private router: Router,
    public snackBarService: SnackBarService,
    private spinnerService: SpinnerService,
    private translate: TranslateService,
    private usersService: UsersService,
    private protocolQTestsService: ProtocolQTestsService,
    private userService: UserService,
    private signatureDocumentService: SignatureDocumentsService,
    private signatureDocumentUsersService: SignatureDocumentUsersService,
    private protocolQTestGeneralDataService: ProtocolQTestGeneralDataService,
    private cdr: ChangeDetectorRef) {
    this.spinnerService.show();
    this.currentUser = this.userService.currentProfile;
    this.route.queryParams.pipe(takeUntil(this.destroy$)).subscribe(params => {
      const id = params[Constants.FIELD_ID] as number;

      if (id == null || isNaN(+id)) {
        this.cancel();
      }

      this.protocol = new ProtocolQ();
      this.protocol.idProcess = 1
      if (+id === 0) {
        let doc = new ReferenceDocument();
        doc.name = this.translate.instant('protocolEdit.referenceDocs.name.default') as string;
        doc.code = this.translate.instant('protocolEdit.referenceDocs.code.default') as string;

        if (!this.protocol.referenceDocs) {
          this.protocol.referenceDocs = [];
        }
        this.protocol.referenceDocs.push(doc);
        this.spinnerService.hide();
      } else {
        this.protocolService.findOne(id).pipe(takeUntil(this.destroy$)).subscribe((result: ProtocolQ) => {
          if (result != null) {
            this.protocol = result;
            this.initializeAttachmentsComponent();
            this.testsSelectedProtocol = _.cloneDeep(result.testPerformed);
            if (this.protocol == null) {
              this.cancel();
              return;
            } else {
              this.form = fb.group({
                idClient: [this.protocol.idClient, [Validators.required]],
                idProcess: [this.protocol.idProcess, [Validators.required]],
                projectNo: [this.protocol.projectNo, [Validators.required]],
                documentCode: [{ value: this.protocol.documentCode, disabled: true }],
                clientDocumentCode: [this.protocol.clientDocumentCode],
                projectManager: [this.protocol.usernameProjectManager],
                regUser: [{ value: this.protocol.regUser, disabled: true }],
                modUser: [{ value: this.protocol.modUser, disabled: true }],
                regFc: [{ value: this.protocol.regFc, disabled: true }],
                modFc: [{ value: this.protocol.modFc, disabled: true }],
                currentVersion: [{ value: this.protocol.currentVersion, disabled: true }],
                signedVersion: [{ value: this.protocol.signedVersion, disabled: true }],
                observations: [{ value: this.protocol.observations }],
                notes: [{ value: this.protocol.notes }],
                department: [{ value: this.protocol.department }]
              });

              this.existsSignerPending();

              this.spinnerService.show();
              this.protocolQTestsService.findByTestTypeId(this.protocol.id).pipe(takeUntil(this.destroy$))
                .subscribe((data: TestQualificationTypeShort[]) => {
                  this.testQualificationTypes = data;
                  data?.forEach(df => {
                    if (this.protocol.testPerformed?.includes(df.qualificationType) || df.idQualificationType === 4) {
                      this.testQualificationTypeList.push(df);
                    }
                  });
                  this.spinnerService.hide();
                });
            }

          } else {
            this.protocol = null;
          }
        }, () => {
          this.protocol = null;
          this.cancel();
        });
      }
    });

    this.form = fb.group({
      idClient: [this.protocol.idClient, [Validators.required]],
      idProcess: [this.protocol.idProcess, [Validators.required]],
      projectNo: [this.protocol.projectNo, [Validators.required]],
      documentCode: [{ value: this.protocol.documentCode, disabled: true }],
      clientDocumentCode: [this.protocol.clientDocumentCode],

      projectManager: [this.protocol.usernameProjectManager],

      regUser: [{ value: this.protocol.regUser, disabled: true }],
      modUser: [{ value: this.protocol.modUser, disabled: true }],
      regFc: [{ value: this.protocol.regFc, disabled: true }],
      modFc: [{ value: this.protocol.modFc, disabled: true }],
      currentVersion: [{ value: this.protocol.currentVersion, disabled: true }],
      signedVersion: [{ value: this.protocol.signedVersion, disabled: true }],
      observations: [{ value: this.protocol.observations }],
      notes: [{ value: this.protocol.notes }],
      department: [{ value: this.protocol.department }]
    });
  }


  initializeAttachmentsComponent(): void {

    if (this.attachmentsComponent instanceof QueryList) {
      this.attachmentsComponent = this.attachmentsComponent.first as ProtocolQEditAttachmentsComponent;
    }
    if (this.attachmentsComponent) {
      this.attachmentsComponent.setIdProtocol(this.protocol.id);
      this.attachmentsComponent.setIdStatus(this.protocol.idStatus);
    }
  }
  ngOnInit(): void {

    this.clients = [];
    this.processes = [];
    this.processService.findAll().pipe(takeUntil(this.destroy$)).subscribe((data: GenericClass[]) => this.processes = data);

    this.respField = [];
    this.usersService.findAllRespFromGroup().pipe(takeUntil(this.destroy$)).subscribe((data: User[]) => this.respField = data);

    this.clientService.findAll().pipe(takeUntil(this.destroy$)).subscribe((data: Client[]) => {
      this.clients = data;
      this.clientsFiltered = this.clients.slice();
    });
  }

  cancel(): void {
    void this.router.navigateByUrl('/qualificates/protocols');
  }

  canEditDocumentCode(): boolean {
    const allowedStatuses = [ProtocolStatus.PENDIENTE_FIRMA];

    return this.protocol.id != null && allowedStatuses.includes(this.protocol.idStatus);
  }

  editDocumentCode(): void {
    const dialogRef = this.dialog.open(EditDocumentCodeEditComponent, {
      minWidth: '50%',
      maxHeight: '95vh',
      data: {
        documentCode: _.cloneDeep(this.protocol.documentCode)
      }
    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result: string) => {
      if (result != null) {
        this.protocol.documentCode = result;
      }
    });
  }

  onTabChange(event: MatTabChangeEvent): void {
    if (event.index === 1) {
      this.auditTab.getAudit();
    }
  }

  showAutomaticSign(): boolean {
    const current = this.currentUser;

    return this.canSign() && current.automaticSign && this.isEnabledSignature && this.disabledSigned();
  }

  showSignature(): boolean {
    const current = this.currentUser;

    return this.canSign() && current.automaticSign && current.admin;
  }

  saveSignatureByUser(token: string) {
    this.spinnerService.show();
    this.signatureDocument.idStatus = 2;
    this.signatureDocumentService.saveDocumentUser(this.signatureDocument, token).subscribe((result: SignatureDocumentUsers) => {
      if (result) {
        this.spinnerService.hide();

        this.snackBarService.sendSuccess(this.translate.instant('protocolEdit.signature.complete.ok') as string);
        if (result.message) {
          const dialogRef = this.dialog.open(ConfirmationDialogSignatureComponent, {
            data: {
              canCancel: false,
              canOk: false,
              icon: true,
              html: true,
              messageOk: this.translate.instant('common.continue'),
              idSignature: this.signatureDocument.idSignature
            }
          });

          dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe(result => {
            this.reloadPage(null);
          });
        } else {
          this.reloadPage(null);
        }
      } else {
        this.spinnerService.hide();
        this.snackBarService.sendError(this.translate.instant('protocolEdit.signature.complete.error') as string);
      }
    }, error => {
      this.spinnerService.hide();
    });
  }

  showManualSign(): boolean {
    const current = this.currentUser;

    return this.canSign() && current.manualSign && ArrayUtils.isEmpty(this.pendingSigns) || this.isEnabledSignature;
  }

  showRevertSign(): boolean {
    return this.protocol.idStatus === ProtocolStatus.FIRMADO;
  }

  saveProtocol(): void {

    const errores: string[] = [];

    if (!this.form.valid) {
      errores.push(this.translate.instant('protocolEdit.form.error.notValid') as string);
    }

    if (!this.protocol.equipments || this.protocol.equipments?.length === 0) {
      errores.push(this.translate.instant('protocolEdit.equipment.error.empty') as string);

    }

    if (errores.length === 0) {
      if (this.protocol.id == null) {
        if (!this.protocol?.testPerformed || this.protocol?.testPerformed?.length === 0) {
          this.snackBarService.sendError(this.translate.instant('protocolEdit.test.error.empty') as string);
        } else {
          this.saveAll();
        }
      } else {

        const showReason = (+this.protocol.signedVersion) !== 0;

        if (showReason) {

          const dialogRef = this.dialog.open(ProtocolEditConfirmSaveComponent, {
            minWidth: '30vw',
            data: {
              protocol: this.protocol,
              reason: this.protocol.reason
            }
          });

          dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result: DialogDataConfirmSave) => {
            if (result != null) {
              this.protocol.reason = result.reason;
              this.saveAll();
            }
          });

        } else {
          this.saveAll();
        }

      }

    } else if (errores.length !== 0) {
      this.snackBarService.sendError(errores.join('\n'));
    }

  }

  createTestsSelected(index: number, test: TestQType): void {
    let isEdit = false;
    let isEditTest = false;
    let idStatus = this.protocol.idStatus;
    let result = this.protocol?.protocolQTest?.find(e => e && e.idTestType === test?.id);

    if (result) {
      isEdit = true;
      if (result.protocolQTestItemGroup) {
        isEditTest = true;
      }
      result.position = test.order;
    } else {
      if (!this.protocol?.protocolQTest) {
        this.protocol.protocolQTest = [];
      }

      const protQTest = new ProtocolQTest();
      protQTest.idTestType = test.id;
      protQTest.position = test.order;

      this.protocol.protocolQTest.push(protQTest);
    }

    this.testQualificationTypeList.forEach(element => {
      element.testQTypes.forEach(elementTypes => {
        const pt = this.protocol.protocolQTest.find(pt => pt.idTestType === elementTypes.id);
        if (pt) {
          pt.position = elementTypes.order;
        }
      });
    });

    this.protocol.protocolQTest.sort((a, b) => a.position - b.position);

    this.protocol.protocolQTest.forEach((element, index) => {
      element.position = index + 1;
    });

    const dialogRef = this.dialog.open(ProtocolQEditTestComponent, {
      minWidth: '80%',
      maxHeight: '95vh',
      data: {
        idStatus,
        idItem: test.id,
        testQType: test,
        isEdit,
        isEditTest,
        data: _.cloneDeep(result),
        equipment: this.protocol.equipments,
        tests: this.protocol?.protocolQTest,
        nProtocol: this.protocol.documentCode,
        protocol: this.protocol
      }
    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((res: ProtocolQTest) => {
      if (res) {
        this.protocol?.protocolQTest?.filter(e => e.idTestType === test.id).forEach(d => {
          d.testDescription = res.testDescription;
          d.regUser = res.regUser;
          d.regDate = res.regDate;
          d.modUser = res.modUser;
          d.modDate = res.modDate;
          d.reason = res.reason;
          d.imageTest = res.imageTest;
          d.protocolQTestItemGroup = res.protocolQTestItemGroup;
          
          if (res.protocolQTestProbeTraceability) {
            d.protocolQTestProbeTraceability = res.protocolQTestProbeTraceability;
          }
          if (res.protocolQTestResults) {
            d.protocolQTestResults = res.protocolQTestResults;
          }

          if (res.protocolQTestVerification) {
            d.protocolQTestVerification = res.protocolQTestVerification;
          }
          if (res.protocolQTestBioindicadores) {
            d.protocolQTestBioindicadores = res.protocolQTestBioindicadores;
          }
          if (res.protocolQTestGeneralData) {
            d.protocolQTestGeneralData = res.protocolQTestGeneralData;
          }

          if (res.protocolQTestEssayGroup) {
            d.protocolQTestEssayGroup = res.protocolQTestEssayGroup;
          }

          if (res.protocolQTestInstrumentalUsed) {
            d.protocolQTestInstrumentalUsed = res.protocolQTestInstrumentalUsed;
          }
        })
      }
      // this.groupSelected = [...res];
    });
  }

  onSelectedItem(test: TestQType, qualificationType: TestQualificationTypeShort, event: MatCheckboxChange): void {
    if (event.checked) {
      if (!this.protocol?.protocolQTest) {
        this.protocol.protocolQTest = [];
      }

      const protocolQTest = new ProtocolQTest();
      protocolQTest.idTestType = test.id;
      protocolQTest.idQualificationType = qualificationType.id;
      this.protocol?.protocolQTest.push(protocolQTest);
    } else {
      const message = this.translate.instant('protocolEdit.test.uncheck.form.confirm') as string;

      const dialogRef = this.dialog.open(ConfirmationDialogComponent, { data: { message } });

      dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe(response => {
        if (response === true) {
          this.protocol.protocolQTest = this.protocol.protocolQTest.filter(e => e.idTestType !== test.id);
          this.protocol.protocolQTest.sort((a, b) => a.position - b.position).forEach((e, indexT) => {
            e.position = indexT
          });
          test.checked = false;
        } else {
          test.checked = true;
        }
        this.cdr.detectChanges();
      });
    }
  }

  openNewRefDoc(): void {
    const dialogRef = this.dialog.open(EditReferenceDocsComponent, {
      minWidth: '50%',
      maxHeight: '95vh',
      data: {
        refDoc: new ReferenceDocument(),
        isEdit: false,
        disabled: false,
        idApp: AppTypeEnum.QUALIFICATES
      }
    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result: ReferenceDocument) => {

      if (result != null) {
        this.protocol.referenceDocs.push(result);

        this.refDocTable.renderRows();
      }
    });
  }

  editRefDoc(refDocIndex: number): void {

    const refDoc = this.protocol.referenceDocs[refDocIndex];

    const dialogRef = this.dialog.open(EditReferenceDocsComponent, {
      minWidth: '50%',
      maxHeight: '95vh',
      data: {
        refDoc: _.cloneDeep(refDoc),
        isEdit: true,
        disabled: false,
        idApp: AppTypeEnum.QUALIFICATES
      }
    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result: ReferenceDocument) => {

      if (result != null) {
        this.protocol.referenceDocs[refDocIndex] = result;

        this.refDocTable.renderRows();
      }
    });
  }

  removeRefDoc(refDocIndex: number): void {
    this.protocol.referenceDocs.splice(refDocIndex, 1);

    this.refDocTable.renderRows();
  }

  openDialogEquipment(): void {
    const dialogRef = this.dialog.open(ProtocolEditEquipmentDialogComponent, {
      minWidth: '80%',
      maxHeight: '95vh',
      data: {
        equipment: new EquipmentQualificates(),
        isEdit: false,
        isOnlyPQ: this.protocol.testPerformed != null && this.protocol.testPerformed[0] === 'pq'
      }
    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result: EquipmentQualificates) => {
      if (result != null) {
        if (this.protocol.equipments == null) {
          this.protocol.equipments = [];
        }
        this.protocol.equipments.push(result);
      }
    });
  }

  openDialogEditEquipment(idx: number): void {
    event.stopPropagation();

    const eq = this.protocol.equipments[idx];

    const dialogRef = this.dialog.open(ProtocolEditEquipmentDialogComponent, {
      minWidth: '80%',
      maxHeight: '95vh',
      data: {
        equipment: _.cloneDeep(eq),
        isEdit: true,
        isOnlyPQ: this.protocol.testPerformed != null && this.protocol.testPerformed[0] === 'pq'
      }
    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result: EquipmentQualificates) => {
      if (result != null) {
        this.protocol.equipments[idx] = result;

        if (this.protocol.protocolQTest) {
          const res = this.protocol.protocolQTest.find(e => e.idTestType === TestTypeEnum.EQUIPMENT_VERIFICATION);

          for (let index = 0; index < res.protocolQTestItemGroup?.length; index++) {
            const element = res.protocolQTestItemGroup[index];
            for (let index = 0; index < element.protocolQTestItems?.length; index++) {
              const elementItem = element.protocolQTestItems[index];

              for (let index = 0; index < elementItem.protocolQTestItemVerification?.length; index++) {
                const elementItemVerification = elementItem.protocolQTestItemVerification[index];

                for (let indexDataMultiple = 0; indexDataMultiple < elementItemVerification.protocolQTestDataMultiple?.length; indexDataMultiple++) {
                  const elementDataMultiple = elementItemVerification.protocolQTestDataMultiple[indexDataMultiple];
                  if (elementDataMultiple?.expectedResultRhDesc) {
                    elementDataMultiple.expectedResultDesc = ProtocolUtils.getEquipmentByField(elementDataMultiple.expectedResultRhDesc, this.protocol.equipments);
                  }
                }
              }
            }
          }
        }
      }
    });
  }


  deleteEquipment(index: number): void {
    event.stopPropagation();

    const message = this.translate.instant('protocolEdit.dialog.equipment.form.confirmDelete') as string;

    const dialogRef = this.dialog.open(ConfirmationDialogComponent, { data: { message } });

    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe(response => {
      if (response === true) {
        if (index > -1) {
          this.protocol.equipments.splice(index, 1);
        }
      }
    });

  }

  showAdjustTemplate(): void {
    const dialogRef = this.dialog.open(ProtocolQEditSectionTemplateComponent, {
      minWidth: '70%',
      maxHeight: '95vh',
      data: {
        protocolData: !this.protocol.protocolQGeneralData ? new ProtocolQGeneralData() : this.protocol.protocolQGeneralData,
        nameClient: this.clients.find(c => c.id === this.protocol.idClient)?.name,
        protocol: this.protocol
      }
    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((protocol: ProtocolQGeneralData
    ) => {
      if (protocol != null) {
        this.protocol.protocolQGeneralData = protocol;
      }
    });
  }

  validateBeforeDownload() {
    let res = false;
    for (let index = 0; index < this.protocol.protocolQTest?.length; index++) {
      const element = this.protocol.protocolQTest[index];

      if (!this.isCompletedTest(element.idTestType)) {
        res = true;
        break;
      }
    }

    if (res) {
      const dialogRefConfirm = this.dialog.open(ConfirmationDialogComponent, {
        data: {
          message: this.translate.instant('generic.test.valid') as string
        }
      });

      dialogRefConfirm.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result: boolean) => {
        if (result === true) {
          this.downloadPdf();
        }
      });
    } else {
      this.downloadPdf();
    }
  }

  downloadPdf(): void {
    this.dialog.open(ProtocolQEditGenerateReportComponent, {
      minWidth: '20%',
      maxHeight: '95vh',
      data: { protocol: this.protocol }
    });
  }

  copyProtocol(): void {

    this.protocolService.copyProtocol(this.protocol.id).subscribe((clonedProtocol: ProtocolQ) => {


      this.protocol = clonedProtocol;
      this.reloadPage();

    });

  }

  isCompletedTest(idTestType: number): boolean {
    const notValidationExpectedResult = [TestTypeEnum.TEST_BOWIE_DICK];
    const notValidationSensor = [TestTypeEnum.TEST_BOWIE_DICK, TestTypeEnum.TEST_TEMPERATURE_DISTRIBUTION_MOISTURE_CO2_WITH_LOAD_OPENING_DOORS, TestTypeEnum.TEST_TIGHTNESS_TEST_VACUUM_TEST_LEAK_TEST, TestTypeEnum.LEAKAGE_TEST, TestTypeEnum.RELATIVE_MOISTURE_TEMPERATURE_DISTRIBUTION_TEST_CO2_IN_VACUUM, TestTypeEnum.TEMPERATURE_PENETRATION_TEST_UNDER_LOAD_TEMPERATURE];

    let res = true;
    const testResult = this.protocol.protocolQTest?.find(e => e && e.idTestType === idTestType);

    if (testResult) {

      if (testResult.protocolQTestItemGroup?.length > 0) {
        for (let index = 0; index < testResult.protocolQTestItemGroup.length; index++) {
          const elementGroup = testResult.protocolQTestItemGroup[index];

          for (let index = 0; index < elementGroup.protocolQTestItems?.length; index++) {
            const element = elementGroup.protocolQTestItems[index];

            if (element.protocolQTestItemVerification?.length > 0) {
              for (let indextiv = 0; indextiv < element.protocolQTestItemVerification?.length; indextiv++) {
                const elementtiv = element.protocolQTestItemVerification[indextiv];

                if (elementtiv.protocolQTestDataMultiple?.length > 0) {
                  for (let indextdm = 0; indextdm < elementtiv.protocolQTestDataMultiple?.length; indextdm++) {
                    const elementTDM = elementtiv.protocolQTestDataMultiple[indextdm];
                    if (!notValidationExpectedResult.includes(idTestType)) {
                      if (!elementTDM.expectedResultDesc && !elementTDM.onlyLine) {
                        res = false;
                      }
                    }
                  }
                } else {
                  res = false;
                }
              }
            }
          }
        }
      } else {
        res = false;
      }

      if (notValidationSensor.includes(idTestType)) {
        if (!testResult.protocolQTestEssayGroup || testResult.protocolQTestEssayGroup?.length === 0) {
          res = false;
        }
      }

      if (!testResult.protocolQTestGeneralData) {
        res = false;
      }
    } else {
      res = false;
    }

    return res;
  }

  automaticSign(): void {
    const dialogRef = this.dialog.open(ProtocolQEditDialogAutomaticSignComponent, {
      minWidth: '50%',
      maxHeight: '95vh',
      data: { protocol: this.protocol }
    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe(result => {

      if (result != null) {
        if (result != null) {
          this.reloadPage();
          /* this.clientService.findOne(this.protocol.idClient).subscribe((client: Client) => {
             
             if (client.idGroup != null) {
               void this.cloneRow(this.protocol.id, client.idGroup).then(() => this.reloadPage());
             } else {
               this.reloadPage();
             }
 
           });*/
        }
      } else {
        this.spinnerService.hide();
      }
    });

  }

  manualSign(): void {
    const dialogRef = this.dialog.open(ProtocolQEditDialogManualSignComponent, {
      minWidth: '20%',
      maxHeight: '95vh',
      data: { protocol: this.protocol }
    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe(result => {
      this.spinnerService.hide();

      if (result != null) {
        this.clientService.findOne(this.protocol.idClient).subscribe((client: Client) => {

          if (client.idGroup != null) {
            void this.cloneRow(this.protocol.id, client.idGroup).then(() => this.reloadPage());
          } else {
            this.reloadPage();
          }

        });
      }
    });

  }

  private cloneRow(id: number, idGroup: number): Promise<void> {

    return new Promise<void>((resolve) => {

      const dialogRefConfirm = this.dialog.open(ConfirmationDialogComponent, {
        data: {
          message: this.translate.instant('generic.clone.sign') as string
        }
      });

      dialogRefConfirm.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result: boolean) => {
        if (result === true) {

          this.spinnerService.show();

          this.protocolService.checkCopyToGroup(id, idGroup).subscribe((res: GenericWarnError) => {
            this.spinnerService.hide();

            const dialogRef = this.dialog.open(CheckWarnsErrorsComponent, {
              minWidth: '20%',
              maxHeight: '95vh',
              data: {
                warns: res.warns,
                errors: res.errors
              }
            });

            dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((canContinue: boolean) => {
              if (canContinue === true) {
                this.spinnerService.show();
                this.protocolService.copyToGroup(id, idGroup).subscribe(() => {
                  this.spinnerService.hide();

                  this.snackBarService.sendSuccess(this.translate.instant('protocolEdit.form.clone.ok') as string);
                  resolve();
                }, () => {
                  this.spinnerService.hide();
                  this.snackBarService.sendError(this.translate.instant('protocolEdit.form.clone.error') as string);
                  resolve();
                });
              } else {
                resolve();
              }
            });
          }, () => {
            this.spinnerService.hide();
            this.snackBarService.sendError(this.translate.instant('protocolEdit.form.clone.error') as string);
            resolve();
          });
        } else {
          resolve();
        }
      });

    });
  }


  private saveAll() {
    const isNew = this.protocol.id == null;

    if (isNew) {
      const client = this.clients.find(e => e.id === this.protocol.idClient);
      this.protocol.protocolQGeneralData = new ProtocolQGeneralData();
      this.protocol.protocolQGeneralData.scope = ProtocolUtils.getScopeQualificates(this.protocol, client.name, client.address, this.translate);
      this.protocol.protocolQGeneralData.target = ProtocolUtils.getTargetQualificates(this.protocol, client.name, this.translate);
      this.protocol.protocolQGeneralData.precedents = ProtocolUtils.getBackgroundQualificates(this.protocol, client.name, this.translate);
      this.protocolQTestGeneralDataService.loadBase64ImageStrategy().pipe(takeUntil(this.destroy$)).subscribe((result: string) => {
        this.protocol.protocolQGeneralData.strategyQualification = ProtocolUtils.getStrategyQualificates(this.protocol, client.name, this.translate, result);
        this.spinnerService.hide();
      });

      this.protocol.protocolQGeneralData.validationTeamResponsibility = this.translate.instant('protocolEdit.engineeringResponsibility');
      this.protocol.protocolQGeneralData.clientResponsibility = this.translate.instant('protocolEdit.clientResponsibility');

      this.processSaveProtocol(isNew, null);
    } else {
      this.requestReason((reason) => {
        this.processSaveProtocol(isNew, reason);
      });
    }
  }

  processSaveProtocol(isNew: boolean, reason: string) {
    const dialogRef = this.dialog.open(ActionConfirmPasswordComponent, {
      minWidth: '20%',
      maxHeight: '95vh',
      data: {}
    });
    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((token: string) => {
      if (token != null) {

        this.spinnerService.show();

        this.protocolService.save(this.protocol, token, reason).pipe(takeUntil(this.destroy$)).subscribe((res: ProtocolQ) => {
          this.protocol = res;
          if (isNew) {
            this.snackBarService.sendSuccess(this.translate.instant('protocolEdit.form.create.ok') as string);
            this.reloadPage();
          } else {
            this.snackBarService.sendSuccess(this.translate.instant('protocolEdit.form.update.ok') as string);
            this.reloadPage();
          }

          this.spinnerService.hide();
        }, err => {
          if (err != null && err.error != null && typeof err.error === 'string') {
            this.snackBarService.sendError(err.error as string);
          } else if (isNew) {
            this.snackBarService.sendError(this.translate.instant('protocolEdit.form.create.error') as string);
          } else {
            this.snackBarService.sendError(this.translate.instant('protocolEdit.form.update.error') as string);
          }

          this.spinnerService.hide();
        });

      } else {
        this.spinnerService.hide();
      }
    });
  }

  private reloadPage(idProtocol = this.protocol.id) {
    if (idProtocol == null) {
      idProtocol = this.protocol.id;
    }

    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    void this.router.navigateByUrl(`qualificates/protocol?id=${idProtocol}`);
  }

  revertSign(): void {

    if (this.protocol.currentlyUsed) {
      this.dialog.open(ConfirmationDialogComponent, {
        data: {
          message: this.translate.instant('protocolEdit.form.revertSign.isInUse') as string,
          canCancel: false,
          messageOk: this.translate.instant('button.accept') as string
        }
      });

      return;
    }

    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        message: this.translate.instant('calibrateEquipmentEdit.form.revertSign.confirm') as string
      }
    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe(result => {
      if (result === true) {
        this.requestReason((reason) => {
          const dialogRefConfirmation = this.dialog.open(ActionConfirmPasswordComponent, {
            minWidth: '20%',
            maxHeight: '95vh',
            data: {}
          });

          dialogRefConfirmation.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((token: string) => {
            this.protocolService.revertSign(this.protocol.id, reason, token).pipe(takeUntil(this.destroy$)).subscribe(() => {
              this.spinnerService.hide();
              this.reloadPage(this.protocol.id);
            });
          }, err => {
            if (err != null && err.error != null && typeof err.error === 'string') {
              this.snackBarService.sendError(err.error as string);
            } else {
              this.snackBarService.sendError(this.translate.instant('protocolEdit.form.revertSign.error') as string);
            }
          });
        });
      }
    });

  }

  prepareToSign(): void {
    const errores = this.getErrorsSign();

    if (errores.length !== 0) {
      this.snackBarService.sendError(errores.join('\n'));
    } else {
      const message = this.translate.instant('signers.sign.user.valid') as string;

      const dialogRef = this.dialog.open(ConfirmationDialogComponent, { data: { message } });

      dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe(response => {
        if (response) {
          this.requestSign((token: string) => {
            this.saveSignatureByUser(token);
          });
        }
      });
    }
  }

  onSelectedTestCheckbox(event) {
    if (event.value?.length < this.testsSelectedProtocol?.length) {
      const resUnselected = this.testsSelectedProtocol?.some(test => event.value?.includes(test));
      if (this.protocol.id != null && resUnselected) {
        const noIncluide = this.testsSelectedProtocol?.filter(test => !event.value?.includes(test));

        if (noIncluide) {
          const resListCheck = this.testQualificationTypeList?.filter(ppqt => noIncluide?.includes(ppqt.qualificationType) && ppqt.testQTypes.map(e => e.checked));

          if (resListCheck?.length > 0) {
            const testSelected = noIncluide?.map(item => this.translate.instant('testQualification.title.' + item));
            const message = this.translate.instant('protocolEdit.test.selected.valid', { testSelected }) as string;

            const dialogRef = this.dialog.open(ConfirmationDialogComponent, { data: { message } });

            dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe(response => {
              if (response) {
                //const testFour = this.protocol.protocolQTest?.find(ppqt => ppqt.idQualificationType === 4);
                this.protocol.protocolQTest = this.protocol.protocolQTest?.filter(ppqt => resListCheck?.some(rlc => rlc.idQualificationType !== ppqt.idQualificationType));
                if (!this.protocol.protocolQTest) {
                  this.protocol.protocolQTest = [];
                }
                //this.protocol.protocolQTest.push(testFour);
                this.automaticListEssay(noIncluide);
                this.cdr.detectChanges();
              } else {
                if (!this.testsSelectedProtocol) {
                  this.testsSelectedProtocol = [];
                }
                for (let index = 0; index < noIncluide.length; index++) {
                  const element = noIncluide[index];
                  this.selectTestPerformed.value = [...this.selectTestPerformed.value, element]; // Añadir la opción seleccionada
                  this.protocol.testPerformed.push(element);
                  this.testsSelectedProtocol.push(element);
                  this.automaticListEssay([]);
                  this.cdr.detectChanges();

                }
              }
            });
          }
        } else {
          this.testsSelectedProtocol = _.cloneDeep(this.protocol.testPerformed);
          this.automaticListEssay([]);
        }
      }
    } else {
      this.testsSelectedProtocol = _.cloneDeep(this.protocol.testPerformed);
      this.automaticListEssay([]);
    }
  }

  automaticListEssay(noInclude: string[]) {
    this.testQualificationTypeList = [];
    this.testQualificationTypes.forEach(pe => {
      if (pe.idQualificationType !== 4) {
        if (this.protocol.testPerformed?.includes(pe.qualificationType)) {
          this.testQualificationTypeList.push(pe);
          this.testQualificationTypeList.forEach(element => {
            element.testQTypes.forEach(elementTypes => {
              const pt = this.protocol.protocolQTest.find(pt => pt.idTestType === elementTypes.id);
              if (pt) {
                pt.position = elementTypes.order;
              }
            });
          });
      
          this.protocol.protocolQTest.sort((a, b) => a.position - b.position);
      
          this.protocol.protocolQTest.forEach((element, index) => {
            element.position = index + 1;
          });
          this.cdr.detectChanges();
        } else if (noInclude?.length > 0 && noInclude.includes(pe.qualificationType)) {
          pe.testQTypes?.forEach(e => e.checked = false);
        }
      } else {
        this.testQualificationTypeList.push(pe);
        this.testQualificationTypeList.forEach(element => {
          element.testQTypes.forEach(elementTypes => {
            const pt = this.protocol.protocolQTest.find(pt => pt.idTestType === elementTypes.id);
            if (pt) {
              pt.position = elementTypes.order;
            }
          });
        });
    
        this.protocol.protocolQTest.sort((a, b) => a.position - b.position);
    
        this.protocol.protocolQTest.forEach((element, index) => {
          element.position = index + 1;
        });
        this.cdr.detectChanges();
      }
    })
  }

  disabledOptionTest(data: string): boolean {
    if (this.protocol.id != null && this.protocol.testPerformed?.length === 1) {
      return this.protocol.testPerformed.includes(data);
    } else {
      return false;
    }
  }

  openDialogSigner() {
    const dialogRef = this.dialog.open(SignatureEditSignersComponent, {
      minWidth: '80%',
      maxHeight: '95vh',
      data: {
        idDocument: this.protocol.id,
        documentType: DocumentListEnum.PROTOCOL_QUALIFICATES,
        nDocument: this.protocol.documentCode,
        idClient: this.protocol.idClient,
        currentVersion: this.protocol.currentVersion
      }
    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result: string) => {
      if (result != null) {
        this.existsSignerPending();
        this.snackBarService.sendSuccess(this.translate.instant('signers.dialog.ok'))
      }
    });
  }

  prepareToSigner() {
    const errores = this.getErrorsSign();

    if (errores.length !== 0) {
      this.snackBarService.sendError(errores.join('\n'));
    } else {
      this.openDialogSigner();
    }
  }

  existsSignerUsernamePending() {
    this.spinnerService.show();

    this.signatureDocumentUsersService.findByUsernameIdDocumentAndIdType(this.currentUser.username, this.protocol.id, DocumentListEnum.PROTOCOL_QUALIFICATES).subscribe((result: SignatureDocumentUsers) => {
      if (result != null) {
        this.isEnabledSignature = true;
        this.signatureDocument = result;
        this.spinnerService.hide();
      } else {
        this.isEnabledSignature = false;
        this.signatureDocument = null;
        this.spinnerService.hide();
      }
    }, error => {
      console.log(error);
      this.spinnerService.hide();
    });
  }

  refuseSign(): void {
    this.requestReason((reason) => {
      this.requestSign((result) => {
        this.spinnerService.show();
        this.signatureDocumentService.refuseToSign(this.signatureDocument.idSignature, this.signatureDocument.id, reason).pipe(takeUntil(this.destroy$)).subscribe(() => {
          this.snackBarService.sendSuccess(this.translate.instant('protocolEdit.signature.reject.ok') as string);
          this.existsSignerPending();
          this.spinnerService.hide();
        }, () => {
          this.snackBarService.sendError(this.translate.instant('protocolEdit.dialog.generateReport.form.reject.error') as string);
          this.spinnerService.hide();
        });
      });
    });

  }

  existsSignerPending() {
    this.spinnerService.show();

    this.signatureDocumentService.findByIdDocumentAndIdType(this.protocol.id, DocumentListEnum.PROTOCOL_QUALIFICATES, this.protocol.currentVersion, true).subscribe((result: SignatureDocument) => {
      if (result != null && result.idStatus === 1) {
        this.existsPendingSignature = true;
        this.spinnerService.hide();
        this.existsSignerUsernamePending();
      } else {
        this.existsPendingSignature = false;
        this.spinnerService.hide();
      }
    }, error => {
      console.log(error);
      this.spinnerService.hide();
    });
  }

  disabledSigned(): boolean {
    return this.existsPendingSignature;
  }

  private requestReason(callback: (reason: string) => void) {
    const dialogRef = this.dialog.open(ReasonDialogComponent, {
      minWidth: '40%',
      maxHeight: '95vh',
      data: {}
    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result: string) => {
      if (result != null) {
        callback(result);
      }
    });
  }

  private getErrorsSign(): string[] {
    const errores: string[] = [];
    if (ArrayUtils.isEmpty(this.protocol.protocolQTest)) {
      errores.push(this.translate.instant('protocolEditQ.test.empty') as string);
    }

    for (let index = 0; index < this.protocol.protocolQTest.length; index++) {
      const element = this.protocol.protocolQTest[index];
      if (ArrayUtils.isEmpty(element.protocolQTestGeneralData)) {
        errores.push(this.translate.instant('protocolEditQ.test.dataGeneral.empty') as string);
      } else if (!this.isCompletedTest(element.idTestType)) {
        errores.push(this.translate.instant('protocolEditQ.test.error'));
      }
    }
    return errores;
  }

  private canSign(): boolean {
    if (this.protocol.idStatus == null) {
      return false;
    }

    const profile = this.userService.currentProfile;

    if (profile == null) {
      return false;
    }

    const validStatuses = [ProtocolStatus.PENDIENTE_FIRMA];

    return validStatuses.includes(this.protocol.idStatus);
  }

  private requestSign(callback: (token: string) => void) {
    this.spinnerService.hide();

    const dialogRef = this.dialog.open(ActionConfirmPasswordComponent, {
      minWidth: '20%',
      maxHeight: '95vh',
      data: {}
    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result: string) => {
      if (result != null) {
        callback(result);
      }
    });
  }
}
